import { render, staticRenderFns } from "./detail2.vue?vue&type=template&id=7514ce4e&scoped=true"
import script from "./detail2.vue?vue&type=script&lang=js"
export * from "./detail2.vue?vue&type=script&lang=js"
import style0 from "./detail2.vue?vue&type=style&index=0&id=7514ce4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7514ce4e",
  null
  
)

export default component.exports